<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">ブログを書き続けることで得られる、リクルーティングツールとしての効果</h1>
                <span class="meta"> Posted in December 2021 </span>


                <figure>
                  <img class="img-fluid" src="img/blog/card/bloggingrecruiting_bw.png" alt="">
                </figure>
                
                <p>先月、フランスを再訪した際、ある成功したフランス人起業家（彼の最初のベンチャーを支援したかったのだが、それはまた別の話）に会った。とにかく、彼は私に刺激を受けたとお世辞を言って会話を始めた。もちろん、私はこの時点で疑心暗鬼になり、オチを期待したり、彼の健全な判断力に対する評価を考え直したりした。しかし、彼は冗談を言っているのではない。彼は、数年前に私が書いたブログ記事に触発されて、ある習慣を身につけ、それが今では彼の会社が人材採用において優位に立っていると述べたのだ。</p>

                <p>具体的には、2013年に私が書いた記事のことだった。<a href="http://rude.vc/ewx7">「起業家にとってのブログの重要性（The importance of blogging for entrepreneurs）」</a>だ。</p>

                <p>当時、私は「ブログを書くことは、恥知らずな自己宣伝ではなく、考えを伝え、意見を透明化し、読者の意見を参考にしてアイデアのベータテストを行うことだ」と述べた。定期的にブログを書くことで、直観力や創造力を鍛えることができる。ブログを書くことで、頭の中が整理され、その分野のリーダーとしての地位を確立することができるのだ。</p>

                <p>特に5つ目のメリットは、私が取材したフランス人起業家にも当てはまった。ブログを長年にわたって継続的に書いてきたことが、今では最も効果的なリクルーティングツールとして実を結んでいるのだ。</p>

                <p>彼によると、人材、特にソフトウェア開発者を採用する市場は、今ヨーロッパ全体で非常に競争が激しいそうだ。スタートアップは、資金力のある既存企業や、最近大規模な資金調達を終えたスタートアップに、開発者を奪われてしまうことが多くなっている。</p>
                
                <p>この男性は、長年にわたってブログで自分の声を確立してきたことで、彼の野心の物語に賛同する忠実な読者を意図せずして集めてしまったのだ。今では、彼が求人情報を掲載すると、既成の読者の恩恵を受けることができる。さらに、この読者からの候補者は、長年にわたって彼の会社のビジョンをすでに教え込まれているため、文化的にもうまく適合することが多いのだ。</p>
                
                <p>ブログは長期的なゲームである。その成果はすぐには現れず、多くの人が早々に放棄してしまう。しかし、この起業家は、長期的な投資の成果を手にしている。今日の人材争奪戦を考えれば、採用プロセスを加速させ、すでに自分のプロジェクトに賛同してくれている人材を集めることで、天文学的なリターンを得ることができる。</p>
                
                <p>確かに、私がブログの力について書いたあの記事から8年の間に世界は変わった。起業家として伝道し、支持者を増やす方法は他にもある。例えば、ポッドキャスティングだ。</p>

                <p>他人の評価に頼らないものを作ることは、無限の可能性を秘めている。Naval Ravikant 氏は、この概念を「許可なき効力（permissionless leverage）」と呼んでいる。</p>
                
                <p>
                  <blockquote class="twitter-tweet">
                    <p lang="en" dir="ltr">Code and media are permissionless leverage. They&#39;re the leverage behind the newly rich. You can create software and media that works for you while you sleep.</p>
                    &mdash; Naval (@naval) <a href="https://twitter.com/naval/status/1002106893265920000?ref_src=twsrc%5Etfw">May 31, 2018</a>
                  </blockquote>
                </p>

                <p>この表現が気に入ったので、私も採用しようと思う。</p>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>
